'use client';

import * as React from 'react';
import CreatePermissionModalContent from '@/app/dashboard/staff-settings/permissions/components/create-permission-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function CreatePermissionModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Create Permission" isOpen={modal?.open === ModalDrawer.CREATE_PERMISSION}>
      <CreatePermissionModalContent />
    </ModalLayout>
  );
}
